import GavelIcon from '@mui/icons-material/Gavel';

const Auction2000Icon = () => {
    return (
        <GavelIcon
            fontSize = 'small'
            sx = {{
                marginLeft: '6px',
            }}
        />
    );
};

export default Auction2000Icon;
